import {Col, IColProps, Row} from 'components/Grid';
import {BannerYouRules} from 'modules/events/components/BannerYouRules';
import {EventListCard} from 'modules/events/components/EventListCard';
import {IEvent} from 'modules/events/types';
import {FC, Fragment, useMemo} from 'react';
import style from './style.module.scss';
import {BannerCertificate} from '../BannerCertificate';

interface IProps {
    events: IEvent[];
}

const GRID_CONFIG = {
    lg: 4,
    md: 6,
    sm: 12,
} as IColProps;

const BANNER_YOU_RULES_INDEX = 3;
const MIN_EVENTS_FOR_CERTIFICATE = 5;
const MAX_EVENTS_FOR_CERTIFICATE_POSITION = 8;

const BannerYouRulesContainer = () => (
    <Col {...GRID_CONFIG}>
        <BannerYouRules />
    </Col>
);

const BannerCertificateContainer = () => (
    <Col {...GRID_CONFIG}>
        <BannerCertificate />
    </Col>
);

export const EventsList: FC<IProps> = ({events}) => {
    // без учета <BannerYouRulesContainer/>
    const bannerCertificateIndex = useMemo(() => {
        if (events.length >= MIN_EVENTS_FOR_CERTIFICATE && events.length < MAX_EVENTS_FOR_CERTIFICATE_POSITION) {
            return events.length;
        }

        if (events.length >= MAX_EVENTS_FOR_CERTIFICATE_POSITION) {
            return MAX_EVENTS_FOR_CERTIFICATE_POSITION;
        }

        return -1;
    }, [events]);

    return (
        <Row className={style.main}>
            {events.map((event, index) => {
                const isBannerYouRulesIndex = index === BANNER_YOU_RULES_INDEX;
                const isBannerCertificateIndex = bannerCertificateIndex === index;

                return (
                    <Fragment key={event.id}>
                        {isBannerYouRulesIndex && <BannerYouRulesContainer />}
                        {isBannerCertificateIndex && <BannerCertificateContainer />}
                        <Col {...GRID_CONFIG}>
                            <EventListCard event={event} />
                        </Col>
                    </Fragment>
                );
            })}
            {events.length === BANNER_YOU_RULES_INDEX && <BannerYouRulesContainer />}
        </Row>
    );
};
